import { ApiConfig } from "../../Config/ApiConfig";
import {createPostDataAction } from "./CommonAction";
import { FAQLIST  , FAQCREATE ,FAQSTATUSCHANGES , FAQDETAILS , FAQUPDATE ,FAQDELETE } from "../../Constants/FaqConstants";


export const FaqlistGetAction = (payload:any) => createPostDataAction(FAQLIST, ApiConfig?.FaqList,payload,false );
export const FaqCrateaAction = (payload:any) => createPostDataAction(FAQCREATE, ApiConfig?.FaqCreate,payload,true );
export const FaqStatusChangesAction = (payload:any) => createPostDataAction(FAQSTATUSCHANGES, ApiConfig?.FaqStatus,payload,true );
export const FaqUpdateAction = (payload:any) => createPostDataAction(FAQUPDATE, ApiConfig?.FaqUpdate,payload,true );
export const FaqDetailsAction = (payload:any) => createPostDataAction(FAQDETAILS, ApiConfig?.Faqdeatils,payload,false );
export const FaqDeleteAction = (payload:any) => createPostDataAction(FAQDELETE, ApiConfig?.FaqDelete,payload,true );
